import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import abacusService from '../services/abacusService';

/** Installed shell entry. Opens the signed-in student's Abacus course home. */
const AbacusPwaEntry: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    let cancelled = false;
    abacusService.getDashboardProgress()
      .then((progress) => {
        if (cancelled) return;
        if (progress.courseId) {
          navigate(`/student-courses/${progress.courseId}/abacus`, { replace: true });
          return;
        }
        navigate('/student-courses', { replace: true });
      })
      .catch(() => {
        if (!cancelled) navigate('/student-courses', { replace: true });
      });
    return () => {
      cancelled = true;
    };
  }, [navigate]);

  return (
    <Box minHeight="60vh" display="flex" alignItems="center" justifyContent="center">
      <CircularProgress />
    </Box>
  );
};

export default AbacusPwaEntry;
